import { render, staticRenderFns } from "./LoudMainFQianYue.vue?vue&type=template&id=e221b1fc&scoped=true"
import script from "./LoudMainFQianYue.vue?vue&type=script&lang=js"
export * from "./LoudMainFQianYue.vue?vue&type=script&lang=js"
import style0 from "./LoudMainFQianYue.vue?vue&type=style&index=0&id=e221b1fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e221b1fc",
  null
  
)

export default component.exports